import { Camera } from "../render/Camera";
import type { Demo, Scene } from "./types";
import { makeWorld, floor, box } from "./helpers";

export const pyramid: Demo = {
	id: "pyramid",
	title: "Box pyramid",
	blurb:
		"A 12-row pyramid settling under warm-started contacts. Stable stacks at low iteration counts are the classic test of a solid solver.",
	category: "Featured",
	build(): Scene {
		const world = makeWorld();
		floor(world, 40);

		const rows = 12;
		const size = 0.8;
		const gap = 0.02;
		for (let r = 0; r < rows; r++) {
			const count = rows - r;
			const y = -size / 2 - r * (size + gap);
			const startX = -((count - 1) * (size + gap)) / 2;
			for (let c = 0; c < count; c++) {
				box(world, startX + c * (size + gap), y, size, size, { friction: 0.6 });
			}
		}

		return { world, camera: new Camera(0, -3.2, 30) };
	},
};
